import { gql } from '@apollo/client'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      metadata
      formReplyId
      parentId
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      documents {
        id
        src
        type
        description
      }
      events {
        id
        status {
          id
          name
        }
        eventDate
        address
        reason {
          id
          name
        }
        document {
          id
          type
          src
        }
        description
      }
      status {
        id
        name
        color
        label
      }
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        type
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      asset {
        id
        name
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          documents {
            id
            src
            type
            description
          }
          description
          reference
          parentReference
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, id }) => {
  const permalinkToken = usePermalinkToken()

  let { data, ...state } = useQuery(QUERY, {
    variables: { id, permalinkToken: permalinkToken },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
